import { Property } from '../../../Property';

export const getPropertyValue = (property: Property): number =>
  property.value ?? property.defaultValue;
